'use client';

import PlusSvg from '@/assets/svgs/contact-lists/plus-small.svg';
import { inter600 } from '@/config/fonts';
import classNames from 'classnames';
import { FieldData, FieldNameOptions } from '../types';

import IconButton from '../../../shared/components/Buttons/IconButton/IconButton';

interface SelectFieldsToMapProps {
  fields: FieldData[];
  onSelectField: (fieldName: FieldNameOptions) => void;
  className?: string;
}

const SelectFieldsToMap = ({
  fields,
  className,
  onSelectField,
}: SelectFieldsToMapProps) => {
  return (
    <div
      className={classNames(
        'group bg-base-100 dark:bg-base-200 relative flex h-[289px] w-60 flex-col overflow-hidden rounded-xl border-[1px] border-dashed border-gray-200 dark:border-gray-700',
        className
      )}>
      <div
        className={classNames(
          'column-header text-gray-default m-1 flex h-8 max-h-8 min-h-8 items-center justify-between px-2 text-sm dark:text-gray-400',
          inter600.className
        )}>
        <span>Select to map</span>
      </div>

      <div className="items flex flex-col gap-[2px] overflow-auto px-2">
        {fields
          ?.filter((f) => !f.isDone)
          ?.map((item, idx) => {
            return (
              <div
                key={idx}
                title={`Map ${item.title} field`}
                tabIndex={-1}
                className="flex h-8 min-h-8 cursor-pointer items-center justify-between gap-[21px] rounded-md pl-2 text-sm select-none hover:bg-gray-100 dark:hover:bg-gray-800"
                onClick={() => {
                  onSelectField(item.name);
                }}>
                <div className="flex gap-2">
                  <span className="text-gray-500 dark:text-gray-400">{item.icon}</span>
                  <span
                    title={item.title}
                    className="text-black-default text-sm dark:text-gray-200">
                    {item.title}
                  </span>
                </div>
                <div>
                  <IconButton
                    title={`Map ${item.title} field`}
                    icon={<PlusSvg />}
                    className="btn-ghost text-primary"
                    onClick={() => {}}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SelectFieldsToMap;
